window.addEventListener("load", () => {

  const form = document.getElementById("beautyQuizForm");

  if (!form) return;

  const steps = document.querySelectorAll(".beauty-step");

  const progressBar = document.querySelector(".beauty-quiz-progress-bar");

  const currentStepText = document.querySelector(".current-step");

  const totalStepsText = document.querySelector(".total-steps");

  const nextButton = document.querySelector(".quiz-next");

  const prevButton = document.querySelector(".quiz-prev");

  const submitButton = document.querySelector(".quiz-submit");

  const successMessage = document.querySelector(".quiz-success-message");

  /*
  ============================================
  SUCCESS STATE AFTER PAGE RELOAD
  ============================================
  */

  if (sessionStorage.getItem("beautyQuizSuccess") === "true") {

    form.style.display = "none";

    successMessage.style.display = "block";

    document.querySelector(".beauty-quiz-progress-wrapper").style.display = "none";

    document.querySelector(".beauty-quiz-counter").style.display = "none";

    document.querySelector(".beauty-quiz-navigation").style.display = "none";

    sessionStorage.removeItem("beautyQuizSuccess");

  }

  let currentStep = 1;

  const totalSteps = steps.length;

  totalStepsText.textContent = totalSteps;

  updateQuizUI();

  /*
  ============================================
  NEXT BUTTON
  ============================================
  */

  nextButton.addEventListener("click", () => {

    if (!validateStep(currentStep)) return;

    if (currentStep < totalSteps) {

      currentStep++;

      updateQuizUI();

      scrollToTop();

    }

  });

  /*
  ============================================
  PREVIOUS BUTTON
  ============================================
  */

  prevButton.addEventListener("click", () => {

    if (currentStep > 1) {

      currentStep--;

      updateQuizUI();

      scrollToTop();

    }

  });

  /*
  ============================================
  FORM SUBMIT
  ============================================
  */

  form.addEventListener("submit", async (e) => {

  console.log("SUBMIT EJECUTADO");

  e.preventDefault();

  submitButton.disabled = true;

    submitButton.textContent = "Guardando...";

    const formData = new FormData(form);

    const payload = {

      customerId: window.customerId,

      color_de_piel: formData.get(
        "customer[metafields][custom][color_de_piel]"
      ),

      tipo_de_piel: formData.get(
        "customer[metafields][custom][tipo_de_piel]"
      ),

      textura_de_cabello: formData.get(
        "customer[metafields][custom][textura_de_cabello]"
      ),

      uso_de_maquillaje: formData.get(
        "customer[metafields][custom][uso_de_maquillaje]"
      ),

      sitios_de_compra: formData.getAll(
        "customer[metafields][custom][sitios_de_compra][]"
      ),

      otras_tiendas: formData.get(
        "customer[metafields][custom][otras_tiendas]"
      ),

      marcas_a_probar: formData.get(
        "customer[metafields][custom][marcas_a_probar]"
      )

    };

    try {

      console.log(payload);

      const response = await fetch(
        "https://beauty-quiz-api.withered-poetry-f8a7.workers.dev/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload)
        }
      );

      const result = await response.json();

      console.log(result);

      /*
      ============================================
      HANDLE GRAPHQL ERRORS
      ============================================
      */

      if (
        result?.data?.metafieldsSet?.userErrors?.length
      ) {

        console.error(result.data.metafieldsSet.userErrors);

        alert("Error guardando perfil.");

        return;
      }

      /*
      ============================================
      SUCCESS
      ============================================
      */

      sessionStorage.setItem(
        "beautyQuizSuccess",
        "true"
      );

      window.location.reload();

    } catch (error) {

      console.error(error);

      submitButton.disabled = false;

      submitButton.textContent = "Guardar perfil";

      console.error(error);

      alert(error.message);

    }

  });

  /*
  ============================================
  UPDATE UI
  ============================================
  */

  function updateQuizUI() {

    steps.forEach((step) => {

      step.classList.remove("active");

    });

    document
      .querySelector(`.beauty-step[data-step="${currentStep}"]`)
      .classList.add("active");

    currentStepText.textContent = currentStep;

    const progressPercent =
      ((currentStep - 1) / (totalSteps - 1)) * 100;

    progressBar.style.width = `${progressPercent}%`;

    if (currentStep === 1) {

      prevButton.style.display = "none";

    } else {

      prevButton.style.display = "inline";

    }

    if (currentStep === totalSteps) {

      nextButton.style.display = "none";

      submitButton.style.display = "inline";

    } else {

      nextButton.style.display = "inline";

      submitButton.style.display = "none";

    }

  }

  /*
  ============================================
  VALIDATE STEP
  ============================================
  */

  function validateStep(stepNumber) {

    const currentStepElement = document.querySelector(
      `.beauty-step[data-step="${stepNumber}"]`
    );

    const requiredFields = currentStepElement.querySelectorAll(
      "input[required]"
    );

    let valid = true;

    requiredFields.forEach((field) => {

      if (field.type === "radio") {

        const radioGroup = currentStepElement.querySelectorAll(
          `input[name="${field.name}"]`
        );

        const isChecked = [...radioGroup].some(
          (radio) => radio.checked
        );

        if (!isChecked) {

          valid = false;

        }

      } else {

        if (!field.value.trim()) {

          valid = false;

        }

      }

    });

    if (!valid) {

      alert("Por favor completa este paso antes de continuar.");

    }

    return valid;

  }

  /*
  ============================================
  SCROLL TO TOP
  ============================================
  */

  function scrollToTop() {

    const quizSection = document.querySelector(
      ".beauty-quiz-section"
    );

    if (!quizSection) return;

    window.scrollTo({
      top: quizSection.offsetTop - 100,
      behavior: "smooth"
    });

  }

});